import { CheckOutStateType } from "store/type"

export enum BikeLabelOrderStepEnum {
	COMMAND_STEP = "COMMAND_STEP",
	EXPEDITION_STEP = "EXPEDITION_STEP",
	SUMMARY_STEP = "SUMMARY_STEP",
	CONFIRMATION_STEP = "CONFIRMATION_STEP",
}

export enum BikeLabelOrderIndexStepEnum {
	COMMAND_STEP = "1",
	EXPEDITION_STEP = "2",
	SUMMARY_STEP = "3",
	CONFIRMATION_STEP = "4",
}

export type BikeLabelStepItem = {
	label: string
	index: `${BikeLabelOrderIndexStepEnum}`
	back: boolean
	title: string
}

export type BikeLabelStepType = {
	[key in BikeLabelOrderStepEnum]: BikeLabelStepItem
}

export type Product = {
	product_id: string
	product_name: string
	product_description: string
	product_description_array: Array<string>
	product_url: string
	prices: Price
	quantity: number
}

export type Price = {
	price_excl_vat: number
	vat_rate: number
}

export type NotActiveOrderType = "0"

//Shipping
export type InformationBiling = {
	invoicing_agent_mail: string
	invoicing_agent_lastname: string
	invoicing_agent_firstname: string
}

export type ErrorsBilingInformation = {
	errorsBilingForm: ErrorsBilingOrderFormCollection
	localErrorBilingForm: boolean
}

export type InformationBilingType = keyof InformationBiling & string

export type ShippingState = InformationBiling &
	ErrorsBilingInformation & {
		sepaInProgress: boolean
	}

export type ErrorBilingOrderForm = {
	message: string
	origin: InformationBilingType
	rule: string
}

export type ConfirmationState = {
	finishOrder: boolean
	orderCustomID: string
	checkOutStateOrderPost: CheckOutStateType
}

//Type of Slice State
export type BikeLabelOrderState = OrderState & ShippingState & ConfirmationState

export type OrderState = {
	checkOutStateProduct: CheckOutStateType
	validatedLabelOrderStep:
		| NotActiveOrderType
		| Exclude<BikeLabelOrderIndexStepEnum, BikeLabelOrderIndexStepEnum.CONFIRMATION_STEP>
	products: Product[]
}

export type ErrorsBilingOrderFormCollection = Array<ErrorBilingOrderForm>

/*
 * Generic type for typing handler context generated
 */

//Recreate string type to Capitalize string type
export type CapitalizeFirst<S extends string> = S extends `${infer First}${infer Rest}`
	? `${Uppercase<First>}${Lowercase<Rest>}`
	: S

//Recreate snake_case type to CamelCase string type
export type CamelCase<S extends string> = S extends `${infer A}_${infer B}`
	? `${CapitalizeFirst<A>}${CapitalizeFirst<B>}`
	: S

//Type of Object with CamelCase function starting by handleTo
export type StepHandlers<T> = {
	[K in keyof T as `handleTo${CamelCase<K & string>}`]: () => void
}

export type BodyPostOrder = {
	order_lines: Array<{ product_id: string; quantity: number }>
	order_data: {
		cgv_version: string
		cgv_accepted_at: string
	}
}

//Type API Route Post Label Order
export type PostLabelCustomId = {
	order_custom_id: string
}
